import React from "react";
import { COLORS } from "../constants/colors.js";
import { FONTS } from "../constants/fonts.js";

// App-wide error boundary. Without one, any uncaught render error unmounts the
// whole React tree and the user is left staring at a blank white page. This
// catches the error and shows a recoverable fallback instead.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info);
  }

  handleReload = () => {
    // Send the user back to a known-good entry point and reload.
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container}>
          <h1 style={styles.title}>Something went wrong</h1>
          <p style={styles.text}>
            The page hit an unexpected error. Returning to the start usually
            fixes it.
          </p>
          <button style={styles.button} onClick={this.handleReload}>
            Reload App
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
    textAlign: "center",
    backgroundColor: COLORS.white,
  },
  title: {
    fontSize: 28,
    fontFamily: FONTS.bold,
    color: COLORS.text,
    marginBottom: 12,
  },
  text: {
    fontSize: 16,
    fontFamily: FONTS.regularInter,
    color: COLORS.gray,
    marginBottom: 24,
    maxWidth: 420,
  },
  button: {
    padding: "12px 24px",
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    border: "none",
    borderRadius: 12,
    fontSize: 16,
    fontFamily: FONTS.bold,
    cursor: "pointer",
  },
};

export default ErrorBoundary;
